import { useContext, useEffect } from "react";
import { Office } from "../../models/office.model";
import { useLocation } from "react-router-dom";
import HomePageHeader from "./HomePageHeader";
import AuthFooter from "../../components/AuthFooter/AuthFooter";
import DoctorRecommendationLink from "./DoctorRecommendationLink";
import { ToastContext } from "../../contexts/ToastContext/ToastContext";
import { SESSION_STORAGE_REQUEST_DATA } from "../../utils/constants";
import RequestFrom from "./RequestForm";
import { FormType } from "../../models";

type LocationState = {
  state: Office;
};

const SingleOffice = () => {
  const toast = useContext(ToastContext);
  const { state } = useLocation() as LocationState;
  const office = state;

  useEffect(() => {
    sessionStorage.removeItem(SESSION_STORAGE_REQUEST_DATA);
  }, []);
  const patientEmail = localStorage.getItem("signPatientEmail");

  return (
    <div className="auth-background">
      <HomePageHeader />
      <div className="relative w-full flex flex-grow justify-center overflow-hidden mt-16">
        <div className="relative z-10 w-full flex items-center justify-center py-12 px-4">
          <div className="w-full flex flex-col lg:flex-row items-center flex-wrap lg:items-center justify-center gap-8 lg:gap-24">
            {/* Left Section - Office Details */}
            <div className="w-full max-w-[340px] flex flex-col items-center">
              <h1 className="text-[32px] font-bold text-white mb-7 text-center">NEW PATIENT SIGN UP</h1>

              {/* Office Card */}
              <div className="w-full bg-[#fff6ef] rounded-2xl p-6 shadow-lg mb-6">
                <div className="space-y-4">
                  <div className="pb-4 border-b border-gray-200">
                    <p className="text-lg font-bold text-navy-blue">{office?.name ?? ""}</p>
                  </div>
                  <div className="flex pb-4 border-b border-gray-200">
                    <p className="text-base text-gray-600 w-24">Address</p>
                    <p className="text-base font-medium text-navy-blue flex-1">
                      {[office?.street, office?.street1, office?.city, office?.state].filter(Boolean).join(", ")}
                    </p>
                  </div>
                  <div className="flex pb-4 border-b border-gray-200">
                    <p className="text-base text-gray-600 w-24">Phone</p>
                    <p className="text-base font-medium text-navy-blue">{office?.phone ?? ""}</p>
                  </div>
                  <div className="flex">
                    <p className="text-base text-gray-600 w-24">Fax</p>
                    <p className="text-base font-medium text-navy-blue">{office?.fax ?? ""}</p>
                  </div>
                </div>
              </div>

              {/* Doctor Recommendation Link */}
              <div className="text-center">
                <p className="text-white mb-1">Your doctor not listed?</p>
                <p className="text-docnote-orange font-medium">
                  <DoctorRecommendationLink />
                </p>
              </div>
            </div>

            {/* Right Section - Signup Form */}
            <div className="w-full max-w-[564px]">
              <div className="bg-[#fff6ef] rounded-2xl p-8 shadow-lg">
                <RequestFrom formType={FormType.PatientSignUp} patientEmail={patientEmail} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-10 bg-[#111C3D] border-t border-white/20 ">
        <AuthFooter extraClasses={"footerContainer mx-auto"} />
      </div> */}
    </div>
  );
};

export default SingleOffice;
